// extracted by mini-css-extract-plugin
export default {"ModeRatio":"LabelToolBox_ModeRatio__l9-62","LeftBox":"LabelToolBox_LeftBox__Pa5dQ","ToolBox":"LabelToolBox_ToolBox__qpBTf","actived":"LabelToolBox_actived__c9tvY"};